import { buildGraphQLQueryParams, cleanStringForFTS } from "../../common/GraphQL/GraphQLQueryHelper";
import simpleFetch from "../../../../utils/simpleFetch";
import { CLIENTS_GRAPHQL, MEMBERS_GRAPHQL } from "../../../utils/data/models";

class SearchApi {
    static searchClients(offset, limit, q, sortBy) {
        const colsStr = `
        clientId
        name
        fullName
        isArchived
    `;
        let cleanQuery = cleanStringForFTS(q);
        cleanQuery && cleanQuery.trim();
        if(cleanQuery) {
            const graphQLQuery = buildGraphQLQueryParams("clientsFts", [], sortBy, offset, limit, colsStr, "getClientsFTS", cleanQuery);
            return simpleFetch("post", CLIENTS_GRAPHQL.path, { body: { query: graphQLQuery } });
        }
    }
    static searchMembers(offset, limit, q, sortBy, additionalFilters=[]) {
        const colsStr = `
            clientId
            memberId
            memberFirstName
            memberLastName
            memberIdentifier
            isArchived
            clientName
            clientFullName
            birthdate
            phoneNumber
            `;
        let cleanQuery = cleanStringForFTS(q);
        cleanQuery && cleanQuery.trim();
        if(cleanQuery) {
            let graphQLFilters = [`members.members_client_fts=like=${cleanQuery}`];
            if(additionalFilters) graphQLFilters = [...graphQLFilters, ...additionalFilters];
            graphQLFilters = graphQLFilters.join(';');
            const graphQLQuery = buildGraphQLQueryParams("membersClientFts", graphQLFilters, sortBy, offset, limit, colsStr, "getMembers", "");
            return simpleFetch("post", MEMBERS_GRAPHQL.path, { body: { query: graphQLQuery } });
        }
    }

    static searchMembersForFollowUps(offset, limit, q, sortBy, additionalFilters=[]) {
        const colsStr = `
            memberId
            clientId
            memberFirstName
            memberLastName
            memberIdentifier
            `;
        let cleanQuery = cleanStringForFTS(q);
        cleanQuery && cleanQuery.trim();
        if(cleanQuery) {
            let graphQLFilters = [`members.members_client_follow_ups_search=like=${cleanQuery}`];
            if(additionalFilters) graphQLFilters = [...graphQLFilters, ...additionalFilters];
            graphQLFilters = graphQLFilters.join(';');
            const graphQLQuery = buildGraphQLQueryParams("membersClientFts", graphQLFilters, sortBy, offset, limit, colsStr, "getMembers", "");
            return simpleFetch("post", MEMBERS_GRAPHQL.path, { body: { query: graphQLQuery } });
        }
    }
}

export default SearchApi;



// WEBPACK FOOTER //
// ./src/components/dashboard/search/searchApi.js